import { useSpringConfig, BARS_LOAD_ANIMATION_CONFIG, BARS_TRANSITION_CONFIG, useChartContext } from '@shopify/polaris-viz-core';

function useBarSpringConfig({
  animationDelay = 0
}) {
  const {
    shouldAnimate
  } = useChartContext();
  return useSpringConfig({
    animationDelay: shouldAnimate ? animationDelay : 0,
    shouldAnimate,
    unmountedSpringConfig: BARS_LOAD_ANIMATION_CONFIG,
    mountedSpringConfig: BARS_TRANSITION_CONFIG
  });
}

export { useBarSpringConfig };
